import { GetPartnerDashboardResponse } from '@/api/type/types';
import { fonts } from '@/theme/fonts';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface DashBoardTodayProps {
  data: GetPartnerDashboardResponse;
}
const DashBoardToday = ({ data }: DashBoardTodayProps) => {
  const { t } = useTranslation();
  return (
    <Section>
      <Title>Today</Title>
      <BoxSection>
        <Box>
          <BoxTop $backColor="#21B837">{t('pending')}</BoxTop>
          <BoxBottom>{data.todaySection.pending}</BoxBottom>
        </Box>
        <Box>
          <BoxTop $backColor="#0004FC">{t('inProgress')}</BoxTop>
          <BoxBottom>{data.todaySection.inProgress}</BoxBottom>
        </Box>
        <Box>
          <BoxTop $backColor="#393C3C">{t('completed')}</BoxTop>
          <BoxBottom>{data.todaySection.completed}</BoxBottom>
        </Box>
      </BoxSection>
    </Section>
  );
};

export default DashBoardToday;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const Title = styled.div`
  width: 135px;
  height: 52px;
  border-radius: 60.5px;
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: normal;
  color: #fafbff;
  background: #b974ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BoxSection = styled.div`
  display: flex;
  gap: 31.11px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 267.56px;
  height: 247px;
  box-sizing: border-box;
`;

interface BoxTopProps {
  $backColor: string;
}

const BoxTop = styled.div<BoxTopProps>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px 40px 0 0;
  background: ${({ $backColor }) => $backColor};
  font-weight: ${fonts.weight.bold};
  font-size: 25px;
  line-height: normal;
  color: #fffcfc;
  white-space: nowrap;
`;

const BoxBottom = styled.div`
  height: 176.4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.family.poppins};
  font-weight: ${fonts.weight.bold};
  font-size: 50px;
  line-height: normal;
  color: #131212;
  border-radius: 0px 0px 40px 40px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
`;
